import React from 'react';
import { useLocation } from 'react-router-dom';
import { getOrgTermsContent } from '../../../../content/utils.js';
import ProjectTabs from '../../../projects/ProjectTabs.jsx';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import { getProjectPage } from '../../../../helpers/breadcrumbRouteHelpers.js';
import { ProjectLink, ProjectsLink } from '../../../links/index.jsx';

const ProjectHeader = ({ project }) => {
  const location = useLocation();
  const projectPage = getProjectPage(location.pathname);
  const renderLastCrumb = () => {
    switch (projectPage) {
      case 'change-impacts':
        return <span>Change Impacts</span>;
      case 'files':
        return <span>Linked Files</span>;
      case 'stakeholders':
        return <span>Stakeholder Analysis</span>;
      case 'change-strategy':
        return <span>Change Strategy</span>;
      case 'initiatives':
        return <span>Initiatives</span>;
      default:
        return <span>Dashboard</span>;
    }
  };

  if (!project) return null;

  return (
    <PageHeader flex navigation={<ProjectTabs project={project} />}>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        {renderLastCrumb()}
      </BreadCrumbs>
    </PageHeader>
  );
};
export default ProjectHeader;
